
import { useEffect, useState } from "react";
import Axios from "axios";

/**
 * 
 * @param url URL
 * @param delay 取得の遅延時間（ミリ秒）
 * @returns 
 */
const useBucketImageLoader = (url?: string, delay?: number) => {

    const [ imgData, setImgData ] = useState<string>();
    const [ status, setStatus ] = useState<LoaderStatus>(LoaderStatus.loading);

    useEffect(() => {
        if (url) {
            setStatus(LoaderStatus.loading)
            getImageBlobData(url, delay).then(blob => {
                setImgData(blob);
                setStatus(LoaderStatus.done)
            }).catch(e => {
                setStatus(LoaderStatus.error);
            })
        } else {
            setImgData(undefined);
            setStatus(LoaderStatus.done);
        }
    }, [url]);

    return {
        loading: status === LoaderStatus.loading,
        error: status === LoaderStatus.error,
        result: imgData,
    }
}

export default useBucketImageLoader;


enum LoaderStatus {
    loading,
    done,
    error
}

/**
 * URLから画像のブロブデータを生成
 * @param url 
 */
 async function getImageBlobData(url: string, delay?: number): Promise<string> {
    try {
        if (delay) {
            await sleep(1000);
        }

        const response = await Axios.get(url, {
            responseType: 'blob'
        })
        
        const reader = new window.FileReader();
        reader.readAsDataURL(response.data);

        return new Promise(resolve => {
            reader.onload = function() {
                const imageDataUrl = reader.result;
                resolve(imageDataUrl as string);
            };
        });
    } catch(e) {
        console.warn('[Warning]: error on getting s3', e);
        throw e;
    }
}

const sleep = (ms: number) => new Promise((res) => setTimeout(res, ms))
